import _assign from "object-assign";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useMemo, useRef } from 'react';
import { useForkRef } from '@material-ui/core/utils';
import { useFormFieldProps } from '@jpmuitk/form-field';
import { itemToString as defaultItemToString, useList, useTypeSelect } from '@jpmuitk/list';
import { useDensity } from '@jpmuitk/theme';
import { useA11yProps, useControlled, useId } from '@jpmuitk/utils';
import { useResizeObserver } from './internal/useResizeObserver';
export function useDropdown() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isMultiSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var a11yProps = useA11yProps();

  var _useFormFieldProps = useFormFieldProps(),
      formFieldFullWidth = _useFormFieldProps.fullWidth,
      formFieldOnFocus = _useFormFieldProps.onFocus,
      formFieldOnBlur = _useFormFieldProps.onBlur;

  var _props$ButtonProps = props.ButtonProps,
      ButtonProps = _props$ButtonProps === void 0 ? {} : _props$ButtonProps,
      ListItem = props.ListItem,
      ListProps = props.ListProps,
      _props$adaExceptions = props.adaExceptions;
  _props$adaExceptions = _props$adaExceptions === void 0 ? {} : _props$adaExceptions;

  var virtualized = _props$adaExceptions.virtualized,
      _props$borderless = props.borderless,
      borderless = _props$borderless === void 0 ? false : _props$borderless,
      buttonRefProp = props.buttonRef,
      children = props.children,
      classes = props.classes,
      densityProp = props.density,
      disabled = props.disabled,
      displayedItemCount = props.displayedItemCount,
      _props$fullWidth = props.fullWidth,
      fullWidthProp = _props$fullWidth === void 0 ? formFieldFullWidth : _props$fullWidth,
      iconName = props.iconName,
      iconSize = props.iconSize,
      idProp = props.id,
      _props$initialIsOpen = props.initialIsOpen,
      initialIsOpen = _props$initialIsOpen === void 0 ? false : _props$initialIsOpen,
      initialSelectedItem = props.initialSelectedItem,
      isOpenProp = props.isOpen,
      _props$itemToString = props.itemToString,
      itemToString = _props$itemToString === void 0 ? defaultItemToString : _props$itemToString,
      listWidthProp = props.listWidth,
      onBlurProp = props.onBlur,
      onButtonClickProp = props.onButtonClick,
      onChangeProp = props.onChange,
      onFocusProp = props.onFocus,
      onMouseLeave = props.onMouseLeave,
      onMouseOver = props.onMouseOver,
      onOpen = props.onOpen,
      onSelect = props.onSelect,
      selectedItemProp = props.selectedItem,
      source = props.source,
      widthProp = props.width,
      rest = _objectWithoutProperties(props, ["ButtonProps", "ListItem", "ListProps", "adaExceptions", "borderless", "buttonRef", "children", "classes", "density", "disabled", "displayedItemCount", "fullWidth", "iconName", "iconSize", "id", "initialIsOpen", "initialSelectedItem", "isOpen", "itemToString", "listWidth", "onBlur", "onButtonClick", "onChange", "onFocus", "onMouseLeave", "onMouseOver", "onOpen", "onSelect", "selectedItem", "source", "width"]);

  var id = useId(idProp);
  var buttonRef = useRef(null);
  var density = useDensity(densityProp);
  var isFullWidth = fullWidthProp !== undefined ? fullWidthProp : formFieldFullWidth;

  var _useResizeObserver = useResizeObserver({
    fullWidth: isFullWidth
  }),
      rootRef = _useResizeObserver.ref,
      observedWidth = _useResizeObserver.width;

  var onButtonKeyDown = ButtonProps.onKeyDown,
      onButtonKeyDownCapture = ButtonProps.onKeyDownCapture,
      restButtonProps = _objectWithoutProperties(ButtonProps, ["onKeyDown", "onKeyDownCapture"]);

  var _useControlled = useControlled({
    controlled: isOpenProp,
    "default": initialIsOpen,
    name: 'useDropdown',
    state: 'isOpen'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      isOpen = _useControlled2[0],
      setIsOpenState = _useControlled2[1];

  var setIsOpen = function setIsOpen(event, newIsOpen) {
    setIsOpenState(newIsOpen);
    onOpen && onOpen(event, newIsOpen);
  };

  var listWidth = useMemo(function () {
    if (isFullWidth) {
      return observedWidth ? observedWidth : undefined;
    } else {
      return listWidthProp ? listWidthProp : widthProp;
    }
  }, [isFullWidth, listWidthProp, observedWidth, widthProp]);

  var _useList = useList(_assign({
    ListItem: ListItem,
    displayedItemCount: displayedItemCount,
    id: "".concat(id, "-list"),
    initialSelectedItem: initialSelectedItem,
    itemToString: itemToString,
    onChange: onChangeProp,
    onSelect: onSelect,
    selectedItem: selectedItemProp,
    selectionVariant: isMultiSelect ? 'multiple' : 'default',
    source: source,
    tabToSelect: !isMultiSelect,
    virtualized: virtualized,
    width: listWidth,
    disableFocus: true,
    disableMouseDown: true
  }, ListProps)),
      focusableRef = _useList.focusableRef,
      state = _useList.state,
      helpers = _useList.helpers,
      listProps = _useList.listProps;

  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex;
  var setHighlightedIndex = helpers.setHighlightedIndex,
      setFocusVisible = helpers.setFocusVisible,
      setSelectedItem = helpers.setSelectedItem;

  var onListBlur = listProps.onBlur,
      onListClick = listProps.onClick,
      onListFocus = listProps.onFocus,
      onListKeyDown = listProps.onKeyDown,
      listId = listProps.id,
      ariaActivedescendant = listProps['aria-activedescendant'],
      ariaMultiselectable = listProps['aria-multiselectable'],
      getItemAtIndex = listProps.getItemAtIndex,
      getItemIndex = listProps.getItemIndex,
      itemCount = listProps.itemCount,
      restListProps = _objectWithoutProperties(listProps, ["onBlur", "onClick", "onFocus", "onKeyDown", "id", "aria-activedescendant", "aria-multiselectable", "getItemAtIndex", "getItemIndex", "itemCount"]); // Set selected item when dropdown is closed and in single selection mode


  var onTypeSelect = function onTypeSelect(event, index) {
    if (!disabled && !isOpen && !isMultiSelect) {
      var newItem = getItemAtIndex(index);
      setSelectedItem(newItem);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(event, newItem);
      onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(event, newItem);
    }
  };

  var _useTypeSelect = useTypeSelect({
    getItemAtIndex: getItemAtIndex,
    highlightedIndex: highlightedIndex,
    itemCount: itemCount,
    itemToString: itemToString,
    setFocusVisible: setFocusVisible,
    setHighlightedIndex: setHighlightedIndex,
    onTypeSelect: onTypeSelect
  }),
      onTypeSelectKeyDownCapture = _useTypeSelect.onKeyDownCapture,
      clearTypeSelectBuffer = _useTypeSelect.clearTypeSelectBuffer;

  var getSelectedItemLabel = function getSelectedItemLabel() {
    if (isMultiSelect && Array.isArray(selectedItem)) {
      if (selectedItem.length === 0) {
        return undefined;
      } else if (selectedItem.length === 1) {
        return itemToString(selectedItem[0]);
      } else {
        return "".concat(selectedItem.length, " items selected");
      }
    } else {
      return selectedItem == null ? undefined : itemToString(selectedItem);
    }
  };

  var syncListFocus = function syncListFocus(event) {
    clearTypeSelectBuffer();

    if (!isOpen) {
      onListFocus(event);
    } else {
      onListBlur(event);
    }
  };

  var handleButtonClick = function handleButtonClick(event) {
    // Do not trigger menu open for 'Enter' and 'SPACE' key as they're handled in `handleButtonKeyDown`
    if (['Enter', ' '].indexOf(event.key) === -1) {
      setIsOpen(event, function (value) {
        return !value;
      });
      syncListFocus(event);
    }

    if (onButtonClickProp) {
      onButtonClickProp(event);
    }
  }; // eslint-disable-next-line complexity


  var handleButtonKeyDown = function handleButtonKeyDown(event) {
    if ('Escape' === event.key) {
      event.preventDefault();
      clearTypeSelectBuffer();

      if (isOpen) {
        setIsOpen(event, false);
        onListBlur(event);
      }
    } else if ('ArrowDown' === event.key) {
      event.preventDefault();
      clearTypeSelectBuffer();

      if (event.altKey) {
        event.stopPropagation();
      }

      if (!isOpen) {
        setIsOpen(event, true);
        onListFocus(event);
      }
    } else if ('Tab' === event.key) {
      clearTypeSelectBuffer();

      if (isOpen) {
        setIsOpen(event, false);
        onListBlur(event);
      }
    } else if (['Enter', ' '].indexOf(event.key) !== -1) {
      event.preventDefault();

      if (!isMultiSelect || !isOpen) {
        setIsOpen(event, function (value) {
          return !value;
        });
        syncListFocus(event);
      }
    } // A lot of keyDown events are shared in the List already


    onListKeyDown(event);

    if (onButtonKeyDown) {
      onButtonKeyDown(event);
    }
  };

  var handleButtonKeyDownCapture = function handleButtonKeyDownCapture(event) {
    if (disabled) {
      return;
    }

    if (onTypeSelectKeyDownCapture) {
      onTypeSelectKeyDownCapture(event);
    }

    if (onButtonKeyDownCapture) {
      onButtonKeyDownCapture(event);
    }
  };

  var handleListClick = function handleListClick(event) {
    if (onListClick) {
      onListClick(event);
    }

    if (!isMultiSelect) {
      setIsOpen(event, false);
    }
  };

  var handleButtonBlur = function handleButtonBlur(event) {
    setIsOpen(event, false);

    if (onListBlur) {
      onListBlur(event);
    }

    if (onBlurProp) {
      onBlurProp(event);
    }

    if (formFieldOnBlur) {
      formFieldOnBlur(event);
    }
  };

  var handleButtonFocus = function handleButtonFocus(event) {
    if (isOpen) {
      onListFocus(event);
    }

    if (onFocusProp) {
      onFocusProp(event);
    }

    if (formFieldOnFocus) {
      formFieldOnFocus(event);
    }
  };

  var dropdownButtonLabelId = "".concat(listId, "--label");

  var ariaLabelledBy = a11yProps['aria-labelledby'],
      restA11yProps = _objectWithoutProperties(a11yProps, ["aria-labelledby"]);

  var getAriaActiveDescendant = function getAriaActiveDescendant() {
    if (isOpen && ariaActivedescendant) {
      return ariaActivedescendant;
    }

    return isMultiSelect ? undefined : dropdownButtonLabelId;
  };

  var dropdownButtonProps = _assign({
    'aria-activedescendant': getAriaActiveDescendant(),
    'aria-expanded': isOpen,
    'aria-multiselectable': ariaMultiselectable,
    'aria-owns': isOpen ? listId : undefined,
    'aria-labelledby': isMultiSelect ? [dropdownButtonLabelId, ariaLabelledBy].join(' ') : ariaLabelledBy,
    ariaHideOptionRole: isOpen,
    role: 'listbox',
    buttonRef: useForkRef(buttonRef, useForkRef(focusableRef, buttonRefProp)),
    classes: {
      content: classes.content,
      buttonLabel: classes.buttonLabel,
      icon: classes.icon,
      formField: classes.formField,
      fullWidth: classes.fullWidth
    },
    className: classes.button,
    density: density,
    disabled: disabled,
    fullWidth: isFullWidth,
    iconName: iconName,
    iconSize: iconSize,
    id: rest.id,
    isOpen: isOpen,
    label: getSelectedItemLabel(),
    labelId: dropdownButtonLabelId,
    // `fullWidth` is handled separately in `DropdownButton`
    style: {
      width: isFullWidth ? undefined : widthProp
    },
    onBlur: handleButtonBlur,
    onClick: disabled ? undefined : handleButtonClick,
    onFocus: handleButtonFocus,
    onKeyDown: disabled ? undefined : handleButtonKeyDown,
    onKeyDownCapture: disabled ? undefined : handleButtonKeyDownCapture,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver
  }, restButtonProps, restA11yProps);

  return {
    rootProps: {
      'aria-expanded': undefined,
      'aria-haspopup': undefined,
      'aria-labelledby': undefined,
      disabled: disabled,
      density: density,
      id: idProp,
      isOpen: isOpen,
      fullWidth: isFullWidth,
      role: undefined,
      ref: rootRef
    },
    buttonProps: dropdownButtonProps,
    listContext: {
      state: state,
      helpers: helpers
    },
    listProps: _assign({
      'aria-multiselectable': ariaMultiselectable,
      'aria-labelledby': a11yProps['aria-labelledby'],
      id: listId,
      borderless: borderless,
      density: density,
      onBlur: onListBlur,
      onClick: handleListClick,
      onFocus: onListFocus,
      onKeyDown: onListKeyDown,
      getItemAtIndex: getItemAtIndex,
      getItemIndex: getItemIndex,
      itemCount: itemCount
    }, restListProps)
  };
}
//# sourceMappingURL=useDropdown.js.map